// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-btn,
.filter-button {
  min-width: 120px !important;
  max-width: 200px !important;
  width: auto !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  padding: 0.25rem 0.75rem !important;
}

/* Ensure filter container is flexible and wraps */
.filter-container {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 0.5rem !important;
  align-items: center !important;
  max-width: 100% !important;
  overflow: visible !important;
}

/* Dropdown menu positioning to prevent overflow */
.dropdown-menu {
  max-width: calc(100vw - 2rem) !important;
  max-height: 300px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

/* Ensure dropdowns don't overflow on the right */
.dropdown {
  position: relative !important;
}

/* On smaller screens, ensure dropdowns don't overflow */
@media (max-width: 768px) {
  .dropdown-menu {
    max-width: calc(100vw - 1rem) !important;
  }
}

.dropdown-item {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  max-width: 100% !important;
}

.clear-filters-btn {
  background: none !important;
  border: none !important;
  color: #dc3545 !important;
  font-size: 12px !important;
  text-decoration: underline !important;
  padding: 0.25rem 0.5rem !important;
  min-width: auto !important;
  width: auto !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.clear-filters-btn:hover {
  color: #c82333 !important;
  text-decoration: underline !important;
}

.clear-filters-btn:focus {
  box-shadow: none !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .filter-btn,
  .filter-button {
    min-width: 100px !important;
    max-width: 150px !important;
    font-size: 11px !important;
    padding: 0.2rem 0.5rem !important;
  }
  
  .filter-container {
    gap: 0.25rem !important;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/CommonComponents/FilterStyles.css"],"names":[],"mappings":"AAAA;;EAEE,2BAA2B;EAC3B,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,kDAAkD;AAClD;EACE,wCAAwC;EACxC,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,kCAAkC;EAClC,0BAA0B;EAC1B,sBAAsB;EACtB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".filter-btn,\n.filter-button {\n  min-width: 120px !important;\n  max-width: 200px !important;\n  width: auto !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  padding: 0.25rem 0.75rem !important;\n}\n\n/* Ensure filter container is flexible and wraps */\n.filter-container {\n  display: flex !important;\n  flex-wrap: wrap !important;\n  gap: 0.5rem !important;\n  align-items: center !important;\n  max-width: 100% !important;\n  overflow: visible !important;\n}\n\n/* Dropdown menu positioning to prevent overflow */\n.dropdown-menu {\n  max-width: calc(100vw - 2rem) !important;\n  max-height: 300px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n}\n\n/* Ensure dropdowns don't overflow on the right */\n.dropdown {\n  position: relative !important;\n}\n\n/* On smaller screens, ensure dropdowns don't overflow */\n@media (max-width: 768px) {\n  .dropdown-menu {\n    max-width: calc(100vw - 1rem) !important;\n  }\n}\n\n.dropdown-item {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  max-width: 100% !important;\n}\n\n.clear-filters-btn {\n  background: none !important;\n  border: none !important;\n  color: #dc3545 !important;\n  font-size: 12px !important;\n  text-decoration: underline !important;\n  padding: 0.25rem 0.5rem !important;\n  min-width: auto !important;\n  width: auto !important;\n  white-space: nowrap !important;\n  flex-shrink: 0 !important;\n}\n\n.clear-filters-btn:hover {\n  color: #c82333 !important;\n  text-decoration: underline !important;\n}\n\n.clear-filters-btn:focus {\n  box-shadow: none !important;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .filter-btn,\n  .filter-button {\n    min-width: 100px !important;\n    max-width: 150px !important;\n    font-size: 11px !important;\n    padding: 0.2rem 0.5rem !important;\n  }\n  \n  .filter-container {\n    gap: 0.25rem !important;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
